<template>
    <v-dialog v-model="dialog" persistent max-width="600px" max-height="1000px">
        <v-card>
            <v-toolbar color="primary">
                <v-icon color="white" class="mr-2">speaker_notes</v-icon>
                <span class="text-h5" style="color: white;">Comunicazione</span>
                <v-spacer></v-spacer>
                <v-icon color="white" @click="chiudi()">close</v-icon>
            </v-toolbar>

            <v-card-text>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-text-field label="Titolo" required v-model="Dettaglio.titolo"></v-text-field>
                        </v-col>
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-autocomplete style="margin-top: -2vh;" :items="select" label="Cliente"
                                item-text="username" item-value="username" v-model="clienteSel" return-object
                                :loading="attesa" clearable hide-details multiple :item-disabled="isDisabled"
                                no-data-text="Nessun dato disponibile"></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row no-gutters class="mt-5">
                        <textarea rows="4" cols="50" style="width: 100%; height: 200px; border: 1px solid black"
                            placeholder="Scrivi qui." v-model="Dettaglio.testo">
</textarea>
                    </v-row>

                    <v-row no-gutters class="mt-5">
                        <v-col class="ma-0 pa-0"></v-col>
                        <v-spacer></v-spacer>

                        <v-col class="ma-0 pa-0">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field hide-details style="width: 120px; margin-top: -1vh;"
                                        v-model="dataPrev1" label="Data inizio" prepend-icon="mdi-calendar" readonly
                                        v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="Dettaglio.dataInizio" @input="menu2 = false" locale="it-it"
                                    :first-day-of-week="1"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col class="ma-0 pa-0">
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field hide-details style="width: 120px; margin-top: -1vh;"
                                        v-model="dataPrev2" label="Data fine" prepend-icon="mdi-calendar" readonly
                                        v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="Dettaglio.dataFine" @input="menu1 = false" locale="it-it"
                                    :first-day-of-week="1"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="chiudi()"> Annulla </v-btn>
                <v-btn color="primary" text @click="salva()"> Salva </v-btn>
            </v-card-actions>
        </v-card>

        <carica-file :dialog="dialogUpload" :idNews="idNews" @chiudi="closeDialog">
        </carica-file>
    </v-dialog>
</template>

<script>
import {
    set_news,
    delete_attachment,
    delete_news,
} from "@/api/api.home.js";
import { get_listaClientiComuicazioni } from "@/api/api.dati.js";

import CaricaFile from "@/components/dialog/CaricaFile.vue";

import mixinNews from "@/utils/dati/mixinNews";

export default {
    components: {
        CaricaFile,
    },

    mixins: [mixinNews],

    props: {
        dialog: { type: Boolean, default: false },
        idNews: { type: Number, default: null },
        modifica: { type: Boolean, default: false },
        notizia: { type: Object, default: null },
    },

    data: () => ({
        loading: false,
        dialogUpload: false,
        elenconews: [],
        menu2: false,
        menu1: false,

        Dettaglio: {},

        select: [],
        clienteSel: [],
        attesa: false,
    }),

    methods: {
        openDialogUpload() {
            this.dialogUpload = true;
        },

        closeDialog(close) {
            this.dialogUpload = false;
        },

        async chiudi() {
            if (!this.modifica) {
                let res = await delete_news(this.idNews);
                if (res.data == "OK") this.$emit("chiudiDialogNews", true);
            } else this.$emit("chiudiDialogNews", false);
        },

        async salva() {
            this.Dettaglio.id = this.idNews;
            //faccio il controllo sui valori inseriti
            if (!this.campiCorretti()) return;

            this.Dettaglio.utente = this.utente;
            this.Dettaglio.cliente = "";
            if (this.clienteSel.length > 0) {
                for (let i = 0; i < this.clienteSel.length; i++) {
                    this.Dettaglio.cliente += this.clienteSel[i].companyCode + "|";
                }
                let res = await set_news(this.Dettaglio);
                if (res.data == "OK") {
                    this.Dettaglio = this.getDettaglioNews();
                    this.select = [];
                    this.clienteSel = [];
                    this.$emit("chiudiDialogNews", true);
                }
                else this.$toast.alert("Impossibile salvare!");
            } else this.$toast.alert("Selezionare il cliente.");
        },

        campiCorretti() {
            if (
                this.Dettaglio.titolo == null ||
                this.Dettaglio.titolo == "" ||
                this.Dettaglio.testo == null ||
                this.Dettaglio.testo == ""
            ) {
                this.$toast.alert("Compilare tutti i campi prima di salvare!");
                return false;
            }
            if (new Date(this.Dettaglio.dataFine) < new Date(this.Dettaglio.dataInizio)) {
                this.$toast.alert("La data di fine deve essere superiore alla data di inizio!");
                return false;
            }
            return true;
        },

        async caricaDati() {
            //Reset
            this.Dettaglio.titolo = "";
            this.Dettaglio.testo = "";
            this.Dettaglio.dataInizio = new Date().toISOString().substr(0, 10);
            this.Dettaglio.dataFine = new Date().toISOString().substr(0, 10);
            if (this.modifica) {
                this.Dettaglio = this.notizia;
                this.Dettaglio.dataInizio = this.notizia.dataInizio.substring(0, 10);
                this.Dettaglio.dataFine = this.notizia.dataFine.substring(0, 10);
            }
        },

        async caricaClienti() {
            // Reset
            this.select = [];
            this.clienteSel = [];

            this.attesa = true;
            //this.select = this.$store.getters["app/getListaClienti"];

            //if (this.select.length == []) {
            let par = {
                Cliente: false,
            }
            let res = await get_listaClientiComuicazioni(par);
            this.select = res.data;
            let cliente = {
                companyCode: "TUTTI",
                enabled: false,
                modificato: false,
                passwordHash: "",
                roleId: "",
                userId: -1,
                username: "TUTTI",
            }
            this.select.unshift(cliente);
            this.$store.commit("app/setListaClienti", this.select);
            this.impostaSelezionato();
            //}
            if (this.Dettaglio.cliente != "" && this.modifica)
                this.setClientiSelect();

            this.attesa = false;
        },

        setClientiSelect() {
            //setto il model di v-autocomplete con i clienti selezionati
            let listaClientiSel = this.Dettaglio.cliente.split('|');
            for (let i = 0; i < this.select.length; i++)
                for (let x = 0; x < listaClientiSel.length; x++)
                    if (listaClientiSel[x] != "" && listaClientiSel[x] == this.select[i].companyCode)
                        if (this.select[i].enabled == true || this.select[i].companyCode == "TUTTI")
                            this.clienteSel.push(this.select[i]);
        },

        impostaSelezionato() {
            // Imposto quello attualmente selezionato
            if (this.$store.state.user.userSwitch == null) return;
            this.cliente = {
                CompCode: this.$store.state.user.userSwitch.CompCode,
                CompName: this.$store.state.user.userSwitch.CompName,
            };
        },

        isDisabled(item) {
            let specialValue = this.select[0];
            let specialSelected = this.clienteSel.includes(specialValue);
            if (specialSelected) {
                return item !== specialValue;
            }
            return false;
        },
    },

    created() {
        this.Dettaglio = this.getDettaglioNews();
    },

    watch: {
        dialog(newVal) {
            if (newVal) {
                this.caricaDati();
                this.caricaClienti();
            }
        },
    },

    computed: {
        dataPrev1() {
            if (this.Dettaglio.dataInizio.length == 0) return "";

            const [year, month, day] = this.Dettaglio.dataInizio.split("-");
            return `${day.substring(0, 2)}/${month}/${year}`;
        },
        dataPrev2() {
            if (this.Dettaglio.dataFine.length == 0) return "";

            const [year, month, day] = this.Dettaglio.dataFine.split("-");
            return `${day.substring(0, 2)}/${month}/${year}`;
        },
        utente() {
            return this.$store.getters["user/getNome"];
        },
    },
};
</script>